<div class='modal-header'>

  <h4 class='modal-title' *ngIf="dialogMode === 'CREATE'">
    {{ "TITLE.NEW_RISK_ASSESSMENT" | translate }}
  </h4>

  <ng-container *ngIf="dialogMode === 'DUPLICATE'">
    <div class="d-flex flex-column">
      <h4 class='modal-title'>{{ "LABELS.DUPLICATE" | translate }}</h4>
      <span class="text-muted fst-italic small" *ngIf="duplicateRiskAssessmentPayload?.payload?.name">
        {{ duplicateRiskAssessmentPayload?.payload?.name}}
      </span>
    </div>
  </ng-container>
</div>

<div class='modal-body'>
  <ng-container *ngIf="formGroup && !loading">
    <form [formGroup]='formGroup'>
      <div class='form-group' *ngIf='checkUsedField("name")'>
        <label class="form-label">{{ 'LABELS.NAME' | translate }}
          <span class='text-danger'>*</span>
        </label>
        <input type='text'
               autocomplete='off'
               formControlName='name'
               [maxLength]='128'
               class='form-control form-control-sm'>
      </div>

      <!--INTERNAL ID----------------------------------------------------------------->
      <pt-input-text-conditional-checkbox
        [label]="'LABELS.INTERNAL_ID' | translate"
        [checkboxLabel]="'LABELS.DEFAULT_INTERNAL_ID' | translate"
        [cleanOnDisable]='true'
        [enableOnCheck]='false'
        [defaultCheckValue]='true'
        [controlName]="'internalId'"
        [activeValidatorsOnlyWhenEnabledInput]='true'
        formControlName='internalId'
        [validators]='[REQUIRED]'
        *ngIf='checkUsedField("internalId")'
      ></pt-input-text-conditional-checkbox>

      <div class='form-group' *ngIf="enabledTempate">
        <label class="form-label">{{ 'LABELS.DESCRIPTION' | translate }}</label>
        <textarea
          autocomplete='off'
          formControlName='description'
          class='form-control form-control-sm'
          [rows]='5'
          aria-describedby='ptWInputHelp'>
          </textarea>
      </div>

      <div class='form-group'>
        <label class="form-label">{{ 'LABELS.LEGAL_ENTITIES' | translate }}</label>
        <ng-select
          class="ng-select-no-border"
          [items]="legalEntities"
          [bindValue]="'id'"
          [multiple]="true"
          [closeOnSelect]="false"
          formControlName="legalEntityIds"
          [bindLabel]="'name'"
          [clearable]="true">
        </ng-select>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf='loading'>
    <div class='loader-container'>
      <pt-loader></pt-loader>
    </div>
  </ng-container>
</div>

<div class='modal-footer' (click)='$event.stopPropagation()'>
  <button type='button' class='btn btn-primary btn-sm'
          [disabled]="formGroup.invalid || loading"
          (click)='confirm(); $event.stopPropagation()'>
    {{ 'BUTTON.CONFIRM' | translate }}
  </button>
  <button type='button' class='btn btn-outline-secondary btn-sm'
          (click)='activeModal.close(false); $event.stopPropagation()'>
    {{ 'BUTTON.CANCEL' | translate }}
  </button>
</div>
